module.exports = __webpack_public_path__ + "static/media/fennanqi.530bd8c7.png";